import grid from './gridv2.module.css'

export default (items, cssClass, interator) => {
   items = items ? items.split(' ') : []
   let classes = []
   
   if(items[0]) classes.push(grid[`${cssClass}-${items[0]}`])
   if(items[1]) classes.push(grid[`${cssClass}-md-${items[1]}`])
   if(items[2]) classes.push(grid[`${cssClass}-lg-${items[2]}`])
   
   return [ ...interator, ...classes]
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Grid/toCssClassesv2.js